module.exports = __webpack_public_path__ + "static/media/world-map-hr.61c9f952.png";